<template>
    <div class="design-estimate">
      <div class="calc-templete">
        <h6>设计概算编制或审核</h6>
        <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>设计概算编制或审核</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
              <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>

            <t-form-item label="工程造价" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入工程造价" suffix="万元（中标价）" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>
            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal"/>


            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item label="基准费用" name="subtotal">
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>

            <t-form-item label="折后费用" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>

            <!-- <t-button class="download" @click="downLoad" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button> -->
              <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>
      </t-form>
      </div>
      <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>投资估算编制或审核计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
             <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
    </div>
  </template>
  
  <script>
  import { bidSocialFees } from '@/api/data'
  import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
  // 设计概算编制或审核
  export default {
    name: 'designEstimate',
    components: {
      // eslint-disable-next-line vue/no-unused-components
      // Help
    },
    data() {
      return {
        jsgc: null,
      visible: false,
      downFileUrl:null,
      openFileUrl: null,
        downLoading:false,
        validateMessage: {
          projectName: [
      {
        type: 'error',
        message: '项目名称不能为空',
      },
    ],
    money: [
      {
        type: 'error',
        message: '请输入规范数字',
      },
    ]
  
  },
        rules: {
          projectName:[{ required: true },  {  type: 'warning' }],
          money:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
          domainCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
          complexityCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
          elevationCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
          otherDesign:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }]
        }, 
        helpOpen:false,
        discountRate: null,
        downData:{},//下载时传值
        formData: {
          id:null,
          ificationId:8,
          projectName: '',
          money: null,
          subtotal: null,
          discountRate: 0,
          discountRateMoney: null,
          result: null
        },
        resultChinese: '',
        fileList: [],
        data: [{
          
        }],
        
        columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '费率(‰)',
          colKey: 'rate',
          width: 100,
        }
  
        ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式

        
      }
    },
    created() {
    this.getList()
  },
    methods: {
      getList() {
      listFile({ classificationId: this.$route.query.ification}).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];

      });
      listRate({ ificationId: this.$route.query.ification}).then(res => {
        let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999){
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
      onReset() {
        this.$message.success('重置成功');
        console.log('formData', this.formData);
      },
      onSubmit({ validateResult, firstError }) {
       if (validateResult === true) {
          this.submit()
          this.$message.success('提交成功');
        } else {
          console.log('Errors: ', validateResult);
          this.$message.warning(firstError);
        }
      },
      downLoad(){
        this.downLoading = true
        this.download('/project/record/excle', {id:this.downData.id,classId:8}
        , `设计概算编制或审核收费计算.xlsx`).then(res => {
  console.log(res)
  this.downLoading = false
        }
        )
      },
      downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'工程造价' + this.formData.money + '（万元）'+ `;让利利率：${this.discountRate}%。`,
        yjwj:this.fileList && this.fileList.fileName || '无文件' || '无文件',
        jsgc:this.jsgc,
        fulx:'设计概算编制或审核',
        zhj:this.formData.result,
      }
      this.download('/project/record/word', { id: this.downData.id, classId: 8,...wordParam }
        , `设计概算编制或审核收费计算.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
      handleClear() {
        this.helpOpen = true
      },
      submit() {
        // console.log(111)
        this.formData.discountRate = Number(this.discountRate) / 100
        bidSocialFees(this.formData).then(res => {
          this.downData = res.data
           this.formData.money = res.data.money.toString()
          this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
          this.formData.result = res.data.result.toFixed(2).toString()
          this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
          // this.formData.money.toString()
          this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
          this.jsgc = res.data.jsgc
        })
      },
      resultChange(value) {
        this.resultChinese = this.changeNumMoneyToChinese(value)
      },
      fileOpenDialog(url) {
      this.downFileUrl =  url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }
    },
  }
  </script>
  
  <style lang="less" >
  .design-estimate {
    background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;
  
  

  }</style>
  